var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.link_class,on:{"click":_vm.logout}},[_c('svg-icon',{staticStyle:{"color":"#498de5","width":"20px","height":"16px"},attrs:{"icon-class":"log-out"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }